import * as React from 'react';
import { render } from 'react-dom';
import Dashboard from './components/Dashboard';

const rootElement = document.getElementById('root');
render(<Dashboard />, rootElement);
